//  Modules from the React eco-system
import { useState, useEffect } from "react"

// Own components
import SubPageNavbar from "../components/navigation/subpage-navbar.component"
import Loader from "../components/loader.component"

// Navigation
import organizersMainRoutes from "../routes/mains/organizers-main.route"
import { Route, Switch, useHistory } from "react-router-dom"

// Axios
import axiosClient from "../api/api"

// Redux
import { setPageName } from "../store/pageSlice"
import { useDispatch } from "react-redux"

// Interfaces, enums
import { IOrganizer } from "../interfaces/persons"
import { ISubPageRoute } from "../interfaces/pages"

function Organizers() {
    const dispatch = useDispatch()
    const history = useHistory()

    const [organizers, setOrganizers] = useState<IOrganizer[]>([])

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        dispatch(setPageName({ pageName: "Organizers", pageUrl: "/admin/organizers/main", subPageName: "" }))
        fetchOrganizers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function fetchOrganizers() {
        setIsLoading(true)
        try {
            const response = await axiosClient.get("/organizer")
            setOrganizers(response.data)
        } catch (error) {
            console.log("Failed to fetch organizers")
            history.push("/admin/404")
        }
        setIsLoading(false)
    }

    return (
        <div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <SubPageNavbar routes={organizersMainRoutes} />

                    <Switch>
                        {organizersMainRoutes.map((route: ISubPageRoute, key: number) => {
                            return (
                                <Route
                                    key={key}
                                    path={route.path}
                                    exact
                                    render={() => {
                                        return (
                                            <div>
                                                <route.component organizers={organizers} setOrganizers={setOrganizers} {...route.props} />
                                            </div>
                                        )
                                    }}
                                />
                            )
                        })}
                    </Switch>
                </>
            )}
        </div>
    )
}

export default Organizers
